export default {"src":"/_next/static/media/AffordableHealthcare.bb820df6.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};